export const CK5CommentMarkerTypeClass = {
  COMMENT: '.ck-comment-marker',
  SUGGESTION: '.ck-suggestion-marker',
  RELEASE_NOTES: '.releasenotes',
};

export type CommentSequence = [number, string][];

export enum CommentTypeEnum {
  COMMENT = 'comment',
  SUGGESTION = 'suggestion',
  RELEASENOTES = 'releasenotes',
}

export enum CommentTypes {
  approveStatus = 'approve',
  rejectStatus = 'reject',
  resolveStatus = 'resolve',
}

export enum CommentTypeKeys {
  draftStatus = 'draft',
  threadId = 'threadId',
  commentKey = 'comments',
}

export type CommentCategory = 'trackchange' | 'editorial'; // any other Category we get in future
export enum CommentCategoryEnum {
  TRACK_CHANGE = 'trackchange',
  EDITORIAL = 'editorial', // // any other Category we get in future,
  RELEASE_NOTES = 'releaseNotes',
}

export interface RangeItems extends Element {
  name: string;
}

export interface Range {
  getItems(): IterableIterator<RangeItems>;
}
